import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import CustomToolTip from '../_tooltip';
import { colourPalette, tickValues, metricLegend, metricFormatFromId } from '../_base';
import { useSelector } from 'react-redux';
import { ArrayHelpers, StringHelpers, SystemText } from 'e4shared';
import { e4Format, e4Formats } from 'helpers/dates';

const Chart = ({ data, axis, item, id, front }) => {
    if (!data || !data[0] || !data[0].data) return <div>{SystemText('Dashboard/Widget/General/InvalidData')}</div>;
    const values = data[0].data;
    const [legend1, setLegend1] = React.useState('Series 1');
    const [legend2, setLegend2] = React.useState('Series 2');
    const [format1, setFormat1] = React.useState('Q');
    const [format2, setFormat2] = React.useState('Q');
    const [bottomTicks, setBottomTicks] = React.useState([]);
    const [leftTicks, setLeftTicks] = React.useState([]);
    const [leftTicksExtra, setLeftTicksExtra] = React.useState({});
    const [rightTicks, setRightTicks] = React.useState([]);
    const [rightTicksExtra, setRightTicksExtra] = React.useState({});

    const metrics = useSelector(state => state.dashboard.metrics);
    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        ArrayHelpers.existsAndHasLength(values) && setBottomTicks(tickValues(values, 'x', me.offsetWidth));
    }, [item.w]);

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        let extra = {};
        ArrayHelpers.existsAndHasLength(values) &&
            setLeftTicks(tickValues(values, 'y', me.offsetHeight, true, extra, format1));
        setLeftTicksExtra(extra);

        ArrayHelpers.existsAndHasLength(values) &&
            setRightTicks(tickValues(values, 'y', me.offsetHeight, true, extra, format2));
        setRightTicksExtra(extra);
    }, [item.h, format1, format2]);

    React.useEffect(() => {
        if (item?.data) {
            const parsed = JSON.parse(item.data);
            setFormat1(metricFormatFromId(parsed.metric1, metrics));
            setFormat2(metricFormatFromId(parsed.metric2, metrics));
            setLegend1(parsed.legend1 || metricLegend(parsed.metric1, metrics, user.currencySymbol, legend1));
            setLegend2(parsed.legend2 || metricLegend(parsed.metric2, metrics, user.currencySymbol, legend2));
        }
    }, [item.data]);

    return (
        <ResponsiveLine
            data={data}
            margin={{ top: 10, right: 60, bottom: 50, left: 60 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear' }}
            curve="monotoneX"
            axisTop={null}
            xFormat={x => e4Format(x, e4Formats.monthShort)}
            axisBottom={
                axis === 'right'
                    ? null
                    : {
                          tickValues: bottomTicks,
                          tickSize: 5,
                          tickPadding: 5,
                          tickRotation: 0,
                          format: x => e4Format(x, e4Formats.monthShort),
                          legend: 'Month',
                          legendOffset: 40,
                          legendPosition: 'middle',
                      }
            }
            axisLeft={
                axis === 'right'
                    ? null
                    : {
                          tickValues: leftTicks,
                          tickSize: 5,
                          tickPadding: 5,
                          tickRotation: 0,
                          format: x =>
                              format1 === 'P' ? parseInt(x * 100, 10) : leftTicksExtra.format ? leftTicksExtra.format(x) : x,
                          legend: `${legend1} ${leftTicksExtra.suffix ?? ''}`,
                          legendOffset: -50,
                          legendPosition: 'middle',
                      }
            }
            axisRight={
                axis === 'right'
                    ? {
                          tickValues: rightTicks,
                          tickSize: 5,
                          tickPadding: 5,
                          tickRotation: 0,
                          //   format: x =>
                          //       format2 === 'P'
                          //           ? parseInt(x * 100, 10)
                          //           : rightTicksExtra.format
                          //           ? rightTicksExtra.format(x)
                          //           : x,
                          format: x => (rightTicksExtra.format ? leftTicksExtra.format(x) : x),
                          legend: `${legend2} ${rightTicksExtra.suffix ?? ''}`,
                          legendOffset: 50,
                          legendPosition: 'middle',
                      }
                    : null
            }
            enableGridX={false}
            enableGridY={front}
            colors={colourPalette[axis === 'right' ? 1 : 0]}
            lineWidth={1.2}
            pointSize={8}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={1}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh
            tooltip={point => (
                <CustomToolTip
                    point={point}
                    yFormat={
                        axis === 'right'
                            ? x => StringHelpers.formatMetric(format2, x, user.currencySymbol)
                            : x => StringHelpers.formatMetric(format1, x, user.currencySymbol)
                    }
                    legend={axis === 'right' ? legend2 : legend1}
                />
            )}
        />
    );
};

export default Chart;
